export default {
  showBillingForm: false,
  yearlyLinks: {
    2: 5,
    3: 6,
    9: 12,
    10: 13,
  },
  error: '',
};
